import { render, staticRenderFns } from "./DynamicCaseTable.vue?vue&type=template&id=732bf816&scoped=true&"
import script from "./DynamicCaseTable.vue?vue&type=script&lang=ts&"
export * from "./DynamicCaseTable.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicCaseTable.vue?vue&type=style&index=0&id=732bf816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732bf816",
  null
  
)

export default component.exports